// extracted by mini-css-extract-plugin
export var container = "_4p-0";
export var disabled = "_4p-4";
export var fullWidth = "_4p-3";
export var lined = "_4p-1";
export var selected = "_4p-5";
export var tab = "_4p-2";